import request from 'utils/request';
import config from 'config/Config';

export default class {
  // 查询会员证件列表
  static queryCertificateList() {
    return request({
      url: `personal/queryMemberCertificate`,
      host: config.HOST_MALL
    });
  }

  // 查询会员证件列表
  static updateCert(params) {
    return request({
      url: `personal/batchSaveCertificate`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  // 提交开票函审核
  static submitInvoicing(params) {
    return request({
      url: 'personal/submitInvoicing',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/Personal/Certificates/CertificatesServ.js